module.exports = __webpack_public_path__ + "static/profile_picture_destroyed_shadow-76d77f087820efcf310066b814d0d0df.png";